// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.prescription.OdOsLocationProductIdsActiveResponse */
/* istanbul ignore next */
@GandalfModel
export class OdOsLocationProductIdsActiveResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	isOdLocationProductActive!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	isOsLocationProductActive!: boolean | null;

	@GandalfProperty({ designType: Number })
	odLocationProductId!: number | null;

	@GandalfProperty({ designType: String })
	odLocationProductName!: string | null;

	@GandalfProperty({ designType: Number })
	osLocationProductId!: number | null;

	@GandalfProperty({ designType: String })
	osLocationProductName!: string | null;

}
